// extracted by mini-css-extract-plugin
export default {"noDataContainer":"NoDataContainer_noDataContainer__LABnD"};